import {Component, OnInit} from '@angular/core';
import {AppSettings} from '../models/AppSettings';
import {AppMenu} from '../models/AppMenu';
import {UserService} from '../service/user.service';
import {RicambiService} from '../service/ricambi.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-tws-toolbar',
    templateUrl: './tws-toolbar.component.html',
    styleUrls: ['./tws-toolbar.component.css']
})
export class TwsToolbarComponent implements OnInit {

    constructor(private ricambiService: RicambiService,private service: UserService, private router: Router) {}
    title = 'app works!';
    subscription: boolean = false;
    profilo: string;
    toggle: boolean = false;
    menu: Array<AppMenu>;
    ngOnInit() {
        this.menu = AppSettings.listaMenu;
        this.subscription = this.service.isLoggedIn();
        this.service.getLoginEvent().subscribe(item => {
            this.subscription = item;
            if (this.service.getProfilo()) {
                this.profilo = this.service.getProfilo().username;
            }
        });
        if (this.service.getProfilo()) {
            this.profilo = this.service.getProfilo().username;
        }
    }

    clickToggle(): void {
        this.toggle = !this.toggle;
    }
    clickMenu(d): void {
        this.toggle = false;
    }

    logout() {
        this.service.logout();
        this.subscription = false;
        this.router.navigate(['login']);
    }

    get utente(): any {
        return this.service.getProfilo();
    }
    
    get imgPath():any{
        return AppSettings.FLAG_PATH;
    }
    
    get sezione() {
        return AppSettings.sezione;
    }
    
    scegliLingua(lingua:any){
        this.service.cambiaLingua(lingua);
        this.ricambiService.resetCategorie();
    }
}



// WEBPACK FOOTER //
// ./src/app/tws-toolbar/tws-toolbar.component.ts